import { Component } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, NavigationStart, RouterEvent, Route } from '@angular/router';
import { DetalheBaseController } from '../../../helpers';
import { DevedorService, TelefoneService, RouterService } from '../../../services';
import { EnderecoService } from 'app/services/endereco.service';
import { EmailService } from 'app/services/email.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
    templateUrl: 'devedor.edit.component.html',
})

export class DevedorEditComponent extends DetalheBaseController {

    model: any = {};    
    accordionOpened: any = {
        telefone: false,
        endereco: false,
        email: false
    };    
    _routerSub: any;
    hasEndereco: boolean = true;
    _currentUser: any;
    
    constructor(route: ActivatedRoute, router: Router, private _devedorService: DevedorService, private _telefoneService: TelefoneService,
        private _enderecoService: EnderecoService, private _emailService: EmailService, private routerService: RouterService) {
        super(route, _devedorService);  
        this._routerSub = routerService;        
        this._currentUser = JSON.parse(localStorage.getItem('currentUserCobranca'));
    }

    ngOnInit() {        
        if (this.type == "edit" || this.id != undefined) {
            let id = this._route.snapshot.params['id'] || this.id;
            this.subGet = this._devedorService.getDevedorLogado().subscribe(result => {
                this.model = result;                         
                if (this.model.enderecosAtivos.length == 0)
                    this.hasEndereco = false;
                this.showForm = true;
                this.modelLoaded.emit({});                
            });
        }
        else {
            this.showForm = true;
        }

        var url: string = this._routerSub.getPreviousUrl();        
        if (url.indexOf('email') > 0) this.accordionOpened.email = true;
        else if (url.indexOf('endereco') > 0) this.accordionOpened.endereco = true;
        else this.accordionOpened.telefone = true;        
    }

    atualizarDevedor() {
        this._devedorService.getDevedorLogado().subscribe(result => {
            this.model = result;
        });
    }

    onClickDesativarTelefone(event) {
        this._dialog.confirm('Confirmar', 'Deseja desativar o telefone (' + event.ddd + ') ' + event.numero + '?', () => {
            this._telefoneService.inativar(event.id).subscribe(result => {
                this.atualizarDevedor();
                this._notificationsService.Sucesso("Confirmar", "Telefone desativado com sucesso.");
            });
        });
    }

    onClickDesativarEmail(event) {
        this._dialog.confirm('Confirmar', 'Deseja desativar o email ' + event.mail + '?', () => {
            this._emailService.inativar(event.id).subscribe(result => {
                this.atualizarDevedor();
                this._notificationsService.Sucesso("Confirmar", "Email desativado com sucesso.");
            });
        });
    }

    getEnderecoId() {
        if (this.model.enderecosAtivos[0] == undefined) return 0;
        return this.model.enderecosAtivos[0].id;
    }

    formataTelefone(value: any) {          
        var valor = value.replace(/\D/g, '');        
        var mascaraFixo = "(99) 9999-9999";
        var mascaraCelular = "(99) 99999-9999";
        var mascaraUtilizada = "";
        
        if (valor.length <= 10)
          mascaraUtilizada = mascaraFixo;      
        else
          mascaraUtilizada = mascaraCelular;
          
        var pad = mascaraUtilizada.replace(/\D/g, '').replace(/9/g, '_');
    
        var valorMask = valor + pad.substring(0, pad.length - valor.length);
       
        var valorMaskPos = 0;
        valor = '';
        for (var i = 0; i < mascaraUtilizada.length; i++) {
          if (isNaN(parseInt(mascaraUtilizada.charAt(i)))) {
            valor += mascaraUtilizada.charAt(i);
          } else {
            valor += valorMask[valorMaskPos++];
          }
        }
      
        if (valor.indexOf('_') > -1) {
          valor = valor.substr(0, valor.indexOf('_'));
        }
    
        return valor;
    }

    voltar =()=> this._location.back();    
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/devedor/edit/devedor.edit.component.ts